"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Price-handling utilities
 *
 * Expects all input prices to be expressed as integers in pennies.
 */
class PriceUtils {
  /**
   * Convert a price value to a string for display.
   * 
   * @param {Integer} price Pennies
   * @param {String} currency optional Currency symbol (`£`)
   * @return {String}
   */
  static getDisplayString(price) {
    let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "£";
    price = (price / 100)?.toFixed(2)?.toString()?.split(".") || [];
    const pounds = price[0] || "0";
    const pence = price[1]?.padEnd(2, "0") || "00";
    return `${pounds < 0 ? "-" : ""}${currency}${Math.abs(pounds)}.${pence || ""}`;
  }

}

var _default = PriceUtils;
exports.default = _default;